module.exports = __webpack_public_path__ + "static/media/stand_1.f8a1284b.png";